import axios from 'axios';
import { req } from './axiosFun';

/**
 * 景点管理
 **/
// 获取景点列表
export const campList = (params) => { return axios.get("/customer/listNotMerge") };
export const campListSave  = (params) => { return req("post", "/customer/addNotMerge", params) };
export const campListDel  = (params) => { return req("post", "/customer/deleteNotMerge", params) };






// WEBPACK FOOTER //
// ./src/api/campsMG12.js